import Vue from 'vue';

// @ts-ignore
const appSetup = window.appSetup || {};
const locale = appSetup.localization?.locale || 'en_US';

const state = () => ({
  benchmarks: {},
  sliderOptions: {},
});

const mutations = {
  setSalaryBenchmarks(currentState, payload) {
    currentState.benchmarks = payload;
  },
  setSalarySliderOptions(currentState, payload) {
    currentState.sliderOptions = payload;
  },
};

const actions = {
  async getSalaryBenchmarks({ state: currentState, commit }) {
    if (Object.keys(currentState.benchmarks).length !== 0) return;
    try {
      const { data } = await this.$api.getSetup(
        this.getters.getApiLink('appSetup.salaryBenchmarkOptions', { locale }),
      );
      if (data.salaryBenchmarks) {
        const benchmarks = Object.fromEntries(
          Object.entries(data.salaryBenchmarks).map(([country, options]) => [
            country === '--' ? '*' : country,
            Object.entries(options).map(([value, label]) => ({
              label: Vue.filter('localeNumberWithCurrencyFormat')(label),
              value,
            })),
          ]),
        );
        commit('setSalaryBenchmarks', benchmarks);
      }
    } catch (e) {
      console.error(e);
    }
  },
  async getSalarySliderOptions({ commit, state: currentState }) {
    if (Object.keys(currentState.sliderOptions).length !== 0) return;
    try {
      const { data } = await this.$api.getSetup(
        this.getters.getApiLink('appSetup.salarySliderOptions', { locale }),
      );
      if (data.salarySlider) {
        commit('setSalarySliderOptions', data.salarySlider);
      }
    } catch (e) {
      console.error(e);
    }
  },
};

const getters = {
  allSalaryOptions: (currentState) => currentState.salaryOptions,
  getSalaryOptions: (currentState) => (key) =>
    (currentState.sliderOptions[key]?.steps || currentState.sliderOptions['*']?.steps || []).map(
      ({ label, amount: value }) => ({
        label: Vue.filter('localeNumberWithCurrencyFormat')(label),
        value,
      }),
    ),
  benchmarks: (currentState) => currentState.benchmarks,
};

export default {
  namespaced: true,

  mutations,
  state,
  actions,
  getters,
};
